import { Directive, HostListener } from '@angular/core';

@Directive({
  selector: '[appPreventExponential]'
})
export class PreventExponentialDirective {

  constructor() { }

  @HostListener('keydown', ['$event']) onKeyDown(event: KeyboardEvent) {
    const isDigit = /[0-9]/.test(event.key);
    const isDecimalPoint = event.key === '.';
    const isBackspace = event.key === 'Backspace';

    if (isDigit || isDecimalPoint || isBackspace) {
      return;
    }
    event.preventDefault();
  }
}